import { Umwandlungsart } from '../v2024';

export const UmwandlungsartEnumLabels = {
    _1: '1' as Umwandlungsart,
    _2: '2' as Umwandlungsart,
    _3: '3' as Umwandlungsart,
    _4: '4' as Umwandlungsart
};

